module.exports = __webpack_public_path__ + "img/logo_header_pro.c7e9df5f.svg";